import type {
  Feature as FeatureInterface,
  OfferImage
} from 'src/types/subscription';
import { DynamicObject } from 'src/utils/commonTypes';
import { TAG_NAME } from 'src/utils/constants/TagNameConstants';
import { SubscriptionFallbackEnums } from 'src/utils/constants/utilConstants';
import { getSubsImageUrl } from 'src/utils/SubscriptionHelper/SubscriptionHelper';

import { Container, Icon, SubTitle, Title } from './styles';
import { useAppStore } from '../../../../hooks/useAppStore';

const IconMapping: DynamicObject = {
  CMS_PLAN_4K_AUDIO_ICON: 'audio',
  CMS_PLAN_4K_VIDEO_ICON: 'video',
  CMS_PLAN_4K_DEVICES_ICON: 'screen',
  CMS_PLAN_MOBILE_VIDEO_ICON: 'video',
  CMS_PLAN_MOBILE_AUDIO_ICON: 'audio',
  CMS_PLAN_MOBILE_DEVICES_ICON: 'screen',
  CMS_PLAN_HD_VIDEO_ICON: 'video',
  CMS_PLAN_HD_AUDIO_ICON: 'audio',
  CMS_PLAN_HD_DEVICES_ICON: 'screen'
};
/**
 * Return the asset mapped from BE to public directory
 * */
const getIconSrc = (
  deviceWidth: number,
  icon?: OfferImage,
  iconName?: string
) => {
  return (
    getSubsImageUrl(deviceWidth, TAG_NAME.SUBS_FEATURE_ICON, icon) ||
    `/webapp-assets/images/pack_${
      IconMapping[iconName as keyof typeof IconMapping] ?? 'fallback'
    }_icon.svg?ver=${process.env.APP_VERSION}`
  );
};

interface ItemProps extends FeatureInterface {
  deviceCount: number;
}

const Feature = (item: ItemProps) => {
  const { translations = {}, appConfig: { deviceWidth = 768 } = {} } =
    useAppStore();
  const NEW_SUBSCRIPTION_STRINGS = translations.subscription ?? {};
  const title = NEW_SUBSCRIPTION_STRINGS[item.text]?.replace(
    '{{number_of_screens}}',
    item.deviceCount
  );
  const subtitle = NEW_SUBSCRIPTION_STRINGS[item.title];

  return (
    <Container data-test-id={`feature_${item.icon}`}>
      <Icon src={getIconSrc(deviceWidth, item.iconSrc, item.icon)} />
      <Title data-test-id={`feature-value-${item.title}`}>{title}</Title>
      <SubTitle data-test-id={`feature-title_${item.text}`}>
        {subtitle}
      </SubTitle>
    </Container>
  );
};
export default Feature;
